import React, { useState } from "react";
import axiosInstance from "../../../Config/axiosInstance";
import { createPortal } from "react-dom";
import "./AddProblems.css";
import { NumericFormat } from "react-number-format";

const AddProblems = ({ vehicleId, onClose, onSaved }) => {
    const [description, setDescription] = useState("");
    const [value, setValue] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    const [showToast, setShowToast] = useState(false);
    
    // Handler pentru NumericFormat
    const handleValueChange = ({ value }) => {
        setValue(value);
    };

    //salveaza problema
    const handleSubmit = async () => {
        if (!description.trim() || !value.trim()) {
            alert("Complete all fields!");
            return;
        }

        setIsSaving(true);

        try {
            // Convertim valoarea formatată pentru trimitere la backend
            const numericValue = value ? parseFloat(value.replace(/\./g, '').replace(',', '.')) : null;
            
            await axiosInstance.post("/autovehicles-problems/", {
                car_details: vehicleId,
                problem: description,
                value: numericValue,
                status: false,
            });

            setShowToast(true);

            setTimeout(() => {
                setShowToast(false);
                onSaved();
            }, 1500);

        } catch (err) {
            console.error(err.response?.data || err);
            setIsSaving(false);
        }
    };

    return (
        <>
            {showToast &&
                createPortal(
                    <div className="global-toast-on-top">
                        ✔ Problem added successfully!
                    </div>,
                    document.body
                )
            }

            {/* POPUP MODAL */}
            <div className="addproblems-page">
                <div className="modal-overlay">
                    <div className="modal-box">

                        <div className="modal-header">
                            <h3 className="modal-title">Problem</h3>
                            <hr className="modal-divider" />
                        </div>

                        <label className="modal-label">Details</label>
                        <textarea
                            className="modal-textarea"
                            placeholder="Type..."
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />

                        <label className="modal-label">Expense (LEI)</label>
                        <NumericFormat
                            value={value}
                            onValueChange={handleValueChange}
                            thousandSeparator="."
                            decimalSeparator=","
                            decimalScale={2}
                            fixedDecimalScale
                            allowNegative={false}
                            allowLeadingZeros={false}
                            inputMode="decimal"
                            className="modal-input"
                            placeholder="0,00"
                            required
                        />

                        <div className="modal-buttons">
                            <button className="modal-btn-cancel" onClick={onClose}>
                                Cancel
                            </button>

                            <button
                                className={`modal-btn-done ${isSaving ? "disabled" : ""}`}
                                onClick={!isSaving ? handleSubmit : undefined}
                                disabled={isSaving}
                            >
                                {isSaving ? "Saving..." : "Save"}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default AddProblems;